import CompanyBillingDetailsRepository from '../repositories/CompanyBillingDetailsRepository';
import { diContainer, serviceNames } from '../diContainer/diContainer';
import TransactionRepository from '../repositories/TransactionRepository';
import CompanyBillingDetails from '../domain/entities/CompanyBillingDetails';
import { FIELD_TYPE } from '../constants/Constants';

class ToggleIsCompanyBillingUseCase {
  private companyBillingDetailsRepository: CompanyBillingDetailsRepository;

  private transactionRepository: TransactionRepository;

  private isCompanyBilling: boolean;

  constructor(isCompanyBilling: boolean) {
    this.isCompanyBilling = isCompanyBilling;
    this.companyBillingDetailsRepository = diContainer.get(
      serviceNames.companyBillingDetailsRepository,
    );
    this.transactionRepository = diContainer.get(
      serviceNames.transactionRepository,
    );
  }

  public async execute(): Promise<void> {
    const {
      transactionRepository,
      companyBillingDetailsRepository,
      isCompanyBilling,
    } = this;

    const transaction = await transactionRepository.getTransaction();
    let companyBillingDetails;
    if (isCompanyBilling) {
      companyBillingDetails = new CompanyBillingDetails();
    } else {
      // eslint-disable-next-line max-len
      const updatedCompanyBillingDetails = companyBillingDetailsRepository.formStore.toCompanyBillingDetails();

      companyBillingDetails = CompanyBillingDetails.fromJSON({
        ...updatedCompanyBillingDetails.attributes,
        [FIELD_TYPE.BILL_TO_COMPANY]: true,
      });
    }

    transaction.setCompanyBillingDetails(companyBillingDetails);
  }
}

export default ToggleIsCompanyBillingUseCase;
